module.exports = __webpack_public_path__ + "img/preview2.d680a06c.svg";